import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/directoryListing/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/directoryListing/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/directoryListing/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/directoryListing/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/directoryListing/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/directoryListing/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/directoryListing/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/directoryListing/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/directoryListing/UPDATE_FAILURE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loading: false,
  creating: false,
  updating: false,
  errors: [],
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
    result: payload.result,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(payload = {}){
  return {
    type: UPDATE_SUCCESS,
    result: payload.result,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function createDirectoryListing(directoryListing, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      directory_listing: directoryListing,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/admin/directory_listings.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.DIRECTORY_LISTING)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess(normalizedJson))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function loadDirectoryListings(options){
  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    const promise = api('/admin/directory_listings.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.DIRECTORY_LISTING_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(normalizedJson.result))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function loadDirectoryListing(directoryListing, options){
  return (dispatch, getState) => {
    const directoryListings = getState().brands
    dispatch(fetchRequest({}))

    const promise = api(`/admin/directory_listings/${directoryListing.id}.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const result = directoryListings.result ? directoryListings.result.slice() : []
        if (!result.includes(json.id)){
          result.push(json.id)
        }

        const normalizedJson = normalize(json, Schemas.DIRECTORY_LISTING)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess({ result }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function updateDirectoryListing(directoryListing, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      directory_listing: directoryListing,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/directory_listings/${directoryListing.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.DIRECTORY_LISTING)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess(normalizedJson))

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return { ...state, loading: true }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return { ...state, creating: true }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        result: action.result,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return { ...state, updating: true }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        result: action.result,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
